import React from 'react';
import { Routes, Route } from 'react-router-dom';

import PrivateRoute from './PrivateRoute';

import Support from '../pages/Support';
import Chat from '../pages/Chat';
import SupportRating from '../pages/SupportRating';

const Root: React.FC<any> = () => {
  return (
    <Routes>
      <Route path="*" element={<Support />} />
      <Route
        path="/chat"
        element={
          <PrivateRoute>
            <Chat />
          </PrivateRoute>
        }
      />
      <Route
        path="/rating"
        element={
          <PrivateRoute>
            <SupportRating />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};

export default Root;
